var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.08203 7.21484C0.835938 6.96875 0.835938 6.55859 1.08203 6.3125L6.38672 0.980469C6.66016 0.734375 7.07031 0.734375 7.31641 0.980469L7.94531 1.60938C8.19141 1.85547 8.19141 2.26562 7.94531 2.53906L3.73438 6.75L7.94531 10.9883C8.19141 11.2617 8.19141 11.6719 7.94531 11.918L7.31641 12.5469C7.07031 12.793 6.66016 12.793 6.38672 12.5469L1.08203 7.21484Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.c008c1d5.svg";
export { ForwardRef as ReactComponent };